import { DatePicker, Typography } from "antd";
import { notify } from "@/shared/utils/notify";
import dayjs from "dayjs";
import { useEffect } from "react";
import { Controller, FieldErrorsImpl } from "react-hook-form";

import { InputError } from "./styled";

const { Text } = Typography;

interface Props {
  width?: string;
  placeHolder: string;
  name: string;
  label?: string;
  dateFormat?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: any;
  defaultValue?: boolean;
}

interface PropsContent {
  errors: Partial<
    FieldErrorsImpl<{
      [x: string]: unknown;
    }>
  >;
  name: string;
  width: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (...event: any[]) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  placeHolder: string;
  label?: string;
  dateFormat?: string;
  defaultValue?: boolean;
}

const DataContent = ({
  width,
  dateFormat,
  errors,
  placeHolder,
  onChange,
  value,
  name,
  label,
}: PropsContent) => {
  useEffect(() => {
    if (errors?.[name]?.message) {
      notify.error(`${errors?.[name]?.message}`);
    }
  }, [errors, name]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width,
        flexDirection: "column",
        marginBottom: 8,
      }}
    >
      {label && (
        <Text
          style={{
            fontSize: 14,
            fontWeight: 500,
            marginBottom: 6,
            color: "#334155",
            display: "block",
          }}
        >
          {label}
        </Text>
      )}
      <DatePicker
        format={dateFormat ? dateFormat : "YYYY-MM-DD"}
        showTime={!!dateFormat}
        style={{ width: "100%" }}
        disabledDate={(current) =>
          !!current && current.isBefore(dayjs().add(-1, "day"))
        }
        status={errors[name] ? "error" : ""}
        placeholder={placeHolder}
        onChange={(val) => onChange(val ? val.toDate() : null)}
        value={value ? dayjs(value) : null}
      />
      {!!errors[name] && (
        <InputError>{errors?.[name]?.message}</InputError>
      )}
    </div>
  );
};

export const InputData = ({
  width = "100%",
  placeHolder,
  dateFormat,
  name,
  label,
  control,
  defaultValue = false,
}: Props) => {
  return (
    <Controller
      shouldUnregister
      control={control}
      name={name}
      render={({ field: { onChange, value }, formState: { errors } }) => {
        return (
          <DataContent
            placeHolder={placeHolder}
            errors={errors}
            name={name}
            onChange={onChange}
            value={value}
            width={width}
            dateFormat={dateFormat}
            defaultValue={defaultValue}
            label={label}
          />
        );
      }}
    />
  );
};
